import {OnlineChatService} from 'modules/online-chat/services/OnlineChatService';
import {ISocialNet, SocialNetType} from 'modules/social-networks/models';
import Icon from 'components/Icon';
import {ICity} from 'modules/locations/models';
import {formatToFooterPhone} from 'core/regex';
import {isEmpty} from 'lodash';

const findLink = (data: ISocialNet[], code: ISocialNet['code'], type?: SocialNetType): string =>
    data.find((item) => item.code === code && Boolean(item.link) && (type === undefined || item.type === type))?.link ??
    '';

interface IFooterLink {
    icon: JSX.Element;
    path?: string;
    code?: string;
}

const buildFooterList = (title: string, linkList: IFooterLink[]) => ({
    title,
    linkList: linkList.filter(({path}) => !isEmpty(path)),
});

export const getFooterSocialList = (data: ISocialNet[]) =>
    buildFooterList('Мы в соцсетях', [
        {code: 'telegram', icon: <Icon icon={'Telegram-xl'} />, path: findLink(data, 'telegram', SocialNetType.Social)},
        {code: 'vk', icon: <Icon icon={'Vk-xl'} />, path: findLink(data, 'vk')},
        {code: 'youtube', icon: <Icon icon={'Youtube'} />, path: findLink(data, 'youtube')},
        {code: 'max', icon: <Icon icon={'Max'} />, path: findLink(data, 'max', SocialNetType.Social)},
    ]);

export const getFooterChatList = (data: ISocialNet[]) => {
    const linkList: IFooterLink[] = [
        {
            code: 'telegram',
            icon: <Icon icon={'Telegram-xl'} />,
            path: findLink(data, 'telegram', SocialNetType.Contact),
        },
        {
            code: 'messenger',
            icon: (
                <button onClick={() => OnlineChatService.openChat()}>
                    <Icon icon={'Footer-chat'} />
                </button>
            ),
            // messenger может не иметь ссылки — тогда открывается чат-виджет
            path: findLink(data, 'messenger'),
        },
        {code: 'phone', icon: <Icon icon={'Footer-phone'} />, path: findLink(data, 'phone')},
    ];

    return {
        title: 'Связаться с нами',
        linkList: linkList.filter(({code, path}) => !isEmpty(path) || 'messenger' === code),
    };
};

export const mountainContactsList = (citiesList: ICity[]) =>
    citiesList
        // TODO: пока не начнет корректно номер Мск прилетать
        .map((city) => (1 === city.id ? {...city, managerPhone: '74955106768'} : city))
        .filter(({phone}) => Boolean(phone))
        .map(({title, phone, managerPhone}) => {
            const number = managerPhone ?? phone;
            return {
                href: `tel:+${number}`,
                text: formatToFooterPhone(number),
                title,
            };
        });
